import { useEffect, useState } from "react";
import ReactDevicePreview from "react-device-preview";
import Link from "@mui/material/Link";
import CircularProgress from "@mui/material/CircularProgress";

import {
	DeviceContainer,
	MessageScreen,
	SmsBubble,
	SmsBubbleWithImage,
	ImageAttachmentWithMessage,
	ImageAttachmentWithoutMessage,
} from "./IphoneMessagePreview.styles";

interface Props {
	messageContent: string;
	imageAttachment?: string;
	s3Url?: string;
}

const IphoneMessagePreview = ({
	messageContent,
	imageAttachment,
	s3Url,
}: Props) => {
	const [message, setMessage] = useState("");

	useEffect(() => {
		const urlRegex =
			/(?:(?:https?|ftp):\/\/|\b(?:[a-z\d]+\.))(?:(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))?\))+(?:\((?:[^\s()<>]+|(?:\(?:[^\s()<>]+\)))?\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))?/g;

		const formattedMessage = messageContent
			.split(" ")
			.reduce((p, c) => {
				if (c.match(urlRegex) !== null) {
					const link = `<a href="${c}" target="_blank">` + c + "</a>";
					p.push(link);
				} else {
					p.push(c);
				}

				return p;
			}, [] as string[])
			.join(" ");

		setMessage(formattedMessage);
	}, [messageContent]);

	return (
		<DeviceContainer>
			<ReactDevicePreview device='iphone8' scale='0.7'>
				<MessageScreen>
					{Boolean(message.length) ? (
						Boolean(imageAttachment) ? (
							<>
								<ImageAttachmentWithMessage>
									<div
										style={
											!Boolean(s3Url)
												? {
														position: "relative",
														backgroundColor: "rgba(0,0,0,0.6)",
														opacity: 0.6,
												  }
												: undefined
										}>
										<img src={imageAttachment} alt='attachment' width='100%' />
										{!Boolean(s3Url) && (
											<CircularProgress
												color='primary'
												sx={{
													position: "absolute",
													top: "35%",
													left: "40%",
													transform: "translate(-50%, -50%)",
												}}
											/>
										)}
									</div>
								</ImageAttachmentWithMessage>
								<SmsBubbleWithImage
									variant='body1'
									dangerouslySetInnerHTML={{
										__html: message,
									}}></SmsBubbleWithImage>
							</>
						) : (
							<SmsBubble
								variant='body1'
								dangerouslySetInnerHTML={{ __html: message }}></SmsBubble>
						)
					) : Boolean(imageAttachment) ? (
						<ImageAttachmentWithoutMessage>
							<div
								style={
									!Boolean(s3Url)
										? {
												position: "relative",
												backgroundColor: "rgba(0,0,0,0.6)",
												opacity: 0.6,
										  }
										: undefined
								}>
								<img src={imageAttachment} alt='attachment' width='100%' />
								{!Boolean(s3Url) && (
									<CircularProgress
										color='primary'
										sx={{
											position: "absolute",
											top: "35%",
											left: "40%",
											transform: "translate(-50%, -50%)",
										}}
									/>
								)}
							</div>
						</ImageAttachmentWithoutMessage>
					) : (
						<SmsBubble variant='body1'>
							Let’s start reaching out to your customer by drafting a
							personalized message. For the best tips to make SMS that convert,
							click this <Link href='#'>link</Link>
						</SmsBubble>
					)}
				</MessageScreen>
			</ReactDevicePreview>
		</DeviceContainer>
	);
};

export default IphoneMessagePreview;
